import de from './de';
import en from './en';

// TODO Set Localization depending on app!
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
export const i18nResources = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
};
